export default function addDomainNamedValuesToAttributes(domains, attribute) {
  const objectWithDomainFieldsAsName = {};
  Object.entries(domains).forEach(([key, value]) => {
    const foundDomain = value.find(
      (valueItem) =>
        Number(valueItem.code) === Number(attribute[key]) &&
        attribute[key] !== null &&
        attribute[key] !== ""
    );
    if (foundDomain) {
      objectWithDomainFieldsAsName[`${key}Name`] = foundDomain.name;
    } else {
      objectWithDomainFieldsAsName[`${key}Name`] = "";
    }
  });
  return objectWithDomainFieldsAsName;
}
